export default __webpack_public_path__ + "static/media/IMRAN HOSSAIN.a0581af2.pdf";